import React from "react";
import { FontAwesome } from "../../FontAwesome";
import { IFlexProps } from "../../Flex";
// import styled from "@emotion/styled";

// == Types ================================================================

interface IProps {
  containerProps?: IFlexProps;
}

// == Constants ============================================================

const DEFAULT_PROPS = {};

// == Component ============================================================

export const Bars = ({ containerProps, ...rest }: IProps) => {
  return <FontAwesome containerProps={containerProps} data-testid="bars" icon="bars" {...rest} />;
};

Bars.defaultProps = DEFAULT_PROPS;

// == Styles ===============================================================
